(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evolved-benefit-mosaic"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('evolved-benefit-mosaic')) {
    customElements.define('evolved-benefit-mosaic', class extends HTMLElement {
      connectedCallback() {
        this.initialFrame = requestAnimationFrame(() => this.initializeRail());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initialFrame);
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.settleTimer);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.events = null;
        this.removeAttribute('data-rail-ready');
      }

      initializeRail() {
        if (this.events || !this.isConnected) return;
        this.rail = this.querySelector('.ev-benefit-mosaic__grid');
        if (!this.rail) return;
        this.cards = Array.from(this.rail.querySelectorAll('.ev-benefit-card'));
        this.previous = this.querySelector('[data-previous-slide]');
        this.next = this.querySelector('[data-next-slide]');
        this.counter = this.querySelector('[data-current-slide]');
        this.events = new AbortController();
        const { signal } = this.events;
        this.mobile = matchMedia('(max-width: 749px)');
        this.current = 0;
        this.target = null;
        this.isSwipe = this.classList.contains('ev-benefit-mosaic--mobile-swipe');

        this.previous?.addEventListener('click', () => this.goTo((this.target ?? this.current) - 1), { signal });
        this.next?.addEventListener('click', () => this.goTo((this.target ?? this.current) + 1), { signal });

        this.rail.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateRail());
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => {
            this.target = null;
            this.updateRail();
          }, 160);
        }, { passive: true, signal });

        this.rail.addEventListener('pointerdown', () => {
          this.target = null;
          this.updateRail();
        }, { passive: true, signal });

        this.rail.addEventListener('keydown', (event) => {
          if (event.target !== this.rail || !this.mobile.matches || !this.isSwipe) return;
          const rtl = getComputedStyle(this.rail).direction === 'rtl';
          const forward = rtl ? 'ArrowLeft' : 'ArrowRight';
          const backward = rtl ? 'ArrowRight' : 'ArrowLeft';
          const current = this.target ?? this.current;
          let index;
          if (event.key === forward) index = current + 1;
          if (event.key === backward) index = current - 1;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.cards.length - 1;
          if (index === undefined) return;
          event.preventDefault();
          this.goTo(index);
        }, { signal });

        this.rail.addEventListener('focusin', (event) => {
          const card = event.target.closest('.ev-benefit-card');
          if (card) this.goTo(this.cards.indexOf(card), false);
        }, { signal });

        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          const card = event.target.closest('.ev-benefit-card');
          if (card) this.goTo(this.cards.indexOf(card), false);
        }, { signal });

        this.resizeObserver = new ResizeObserver(() => {
          this.rail.tabIndex = this.mobile.matches && this.isSwipe && this.cards.length > 1 ? 0 : -1;
          if (this.mobile.matches && this.isSwipe) this.goTo(this.target ?? this.current, false);
          this.updateRail();
        });
        this.resizeObserver.observe(this.rail);
        this.querySelector('.ev-benefit-mosaic__arrows')?.removeAttribute('hidden');
        this.setAttribute('data-rail-ready', '');
        this.updateRail();
      }

      updateRail() {
        if (!this.mobile.matches || !this.isSwipe) return;
        const railBounds = this.rail.getBoundingClientRect();
        const rtl = getComputedStyle(this.rail).direction === 'rtl';
        let closest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const bounds = card.getBoundingClientRect();
          const offset = Math.abs(rtl ? bounds.right - railBounds.right : bounds.left - railBounds.left);
          if (offset < distance) {
            distance = offset;
            closest = index;
          }
        });
        this.current = closest;
        if (this.counter && this.counter.textContent !== String(closest + 1)) {
          this.counter.textContent = String(closest + 1);
        }
        const controlIndex = this.target ?? closest;
        if (this.previous) this.previous.disabled = controlIndex === 0;
        if (this.next) this.next.disabled = controlIndex === this.cards.length - 1;
      }

      goTo(index, animate = true) {
        if (!this.mobile.matches || !this.isSwipe || !this.cards.length) return;
        index = Math.max(0, Math.min(index, this.cards.length - 1));
        const railBounds = this.rail.getBoundingClientRect();
        const cardBounds = this.cards[index].getBoundingClientRect();
        const rtl = getComputedStyle(this.rail).direction === 'rtl';
        const delta = rtl ? cardBounds.right - railBounds.right : cardBounds.left - railBounds.left;
        this.target = index;
        this.rail.scrollTo({
          left: this.rail.scrollLeft + delta,
          behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'
        });
        this.updateRail();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-evolved"]) return;
  try {
    
  (() => {
    const enhanceTables = (root = document) => {
      root.querySelectorAll('[data-ec-article] table').forEach((table) => {
        table.closest('.ec-table-scroll')?.removeAttribute('tabindex');
        const labels = Array.from(table.querySelectorAll('thead th')).map((cell) => cell.textContent.trim());

        table.querySelectorAll('tbody tr').forEach((row) => {
          Array.from(row.children).forEach((cell, index) => {
            if (index > 0 && labels[index]) {
              cell.dataset.label = labels[index];
            }
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => enhanceTables(), { once: true });
    } else {
      enhanceTables();
    }

    document.addEventListener('shopify:section:load', (event) => enhanceTables(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
